import { render, staticRenderFns } from "./CommercialOtherUniqueSingleTenant.vue?vue&type=template&id=3f960032&scoped=true&"
import script from "./CommercialOtherUniqueSingleTenant.vue?vue&type=script&lang=ts&"
export * from "./CommercialOtherUniqueSingleTenant.vue?vue&type=script&lang=ts&"
import style0 from "./CommercialOtherUniqueSingleTenant.vue?vue&type=style&index=0&id=3f960032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f960032",
  null
  
)

export default component.exports